export const intToNote = (val) => {
    const octave = Math.floor(val / 12).toString();

    const pitchclass = val % 12;

    const conversion = {
        9: "A",
        10: "A#",
        11: "B",
        0: "C",
        1: "C#",
        2: "D",
        3: "D#",
        4: "E",
        5: "F",
        6: "F#",
        7: "G",
        8: "G#"
    };

    return conversion[pitchclass] + octave;
}